import { Routes, Route } from 'react-router-dom';
import { FEATURES } from './extractFeaturesList.js';
import ProtectedRoute from './protectedRoutes.js';
import AssetBrowser from '../pages/assetBrowser/AssetBrowser';
import Registration from '../pages/registration/Registration';
import AssetDashboard from '../pages/assetDashboard/AssetDashboard';
import UploadedFiles from '../pages/uploadedFiles/UploadedFiles';
import DeviceAuditLogs from '../pages/deviceAuditLogs/DeviceAuditLogs';
import DataItems from '../pages/dataitems/Dataitems';
import DeviceDetails from '../pages/deviceDetails/DeviceDetails';
import GlobalAuditLogs from '../pages/globalAuditLogs/GlobalAuditLogs';
import FileBrowsing from '../pages/fileBrowsing/FileBrowsing';
import SCMHome from '../pages/scm/home/SCMHome';
import CreatePackage from '../pages/scm/createPackage/CreatePackage';
import AddDependencies from '../pages/scm/addDependencies/AddDependencies';
import ManageDependencies from '../pages/scm/manageDependencies/ManageDependencies';
import SelectTargets from '../pages/scm/selectTargets/SelectTargets';
import FindPackage from '../pages/scm/findPackage/FindPackage';
import PublishPackageSummary from '../pages/scm/publishPackageSumarry/PublishPackageSummary';
import Error404 from '../pages/error404/Error404.js';
import CreateDeployment from '../pages/scm/createDeployment/CreateDeployment';
import TrackDeployment from "../pages/scm/trackDeployment/TrackDeployment.js";
import TrackDeploymentForAssets from '../pages/scm/trackDeployment/trackDeploymentForAssets/TrackDeploymentForAssets.js';
import DeploymentSummary from '../pages/scm/deploymentSummary/DeploymentSummary.js';
import FileToMachine from '../pages/fileToMachine/FileToMachine.js';
import UserManagement from '../pages/userManagement/UserManagement.js';
import { SoftwareManagementIndex } from './extractFeaturesList.js';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute allowedFeature={FEATURES.ASSET_BROWSER}>
            <AssetBrowser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/registration"
        element={
          <ProtectedRoute allowedFeature={FEATURES.ASSET_REGISTRATION}>
            <Registration />
          </ProtectedRoute>
        }
      />

      <Route
        path="/asset-dashboard"
        element={
          <ProtectedRoute allowedFeature={FEATURES.ASSET_DASHBOARD}>
            <AssetDashboard />
          </ProtectedRoute>
        }>
        <Route
          index
          element={
            <ProtectedRoute allowedFeature={FEATURES.ASSET_DASHBOARD}>
              <UploadedFiles />
            </ProtectedRoute>
          } />
        <Route
          path="Uploaded-Files"
          element={
            <ProtectedRoute allowedFeature={FEATURES.ASSET_DASHBOARD}>
              <UploadedFiles />
            </ProtectedRoute>
          } />
        <Route
          path="Device-Audit-Logs"
          element={
            <ProtectedRoute allowedFeature={FEATURES.ASSET_DASHBOARD}>
              <DeviceAuditLogs />
            </ProtectedRoute>
          } />
        <Route
          path="Data-Items"
          element={
            <ProtectedRoute allowedFeature={FEATURES.ASSET_DASHBOARD}>
              <DataItems />
            </ProtectedRoute>
          } />
        <Route
          path="Device-Details"
          element={
            <ProtectedRoute allowedFeature={FEATURES.ASSET_DASHBOARD}>
              <DeviceDetails />
            </ProtectedRoute>
          } />
        <Route
          path="file-from-machine"
          element={
            <ProtectedRoute allowedFeature={FEATURES.ASSET_DASHBOARD}>
              <FileBrowsing />
            </ProtectedRoute>
          } />
        <Route
          path="file-to-machine"
          element={
            <ProtectedRoute allowedFeature={FEATURES.ASSET_FILETOMACHINE}>
              <FileToMachine />
            </ProtectedRoute>
          } />
      </Route>
      <Route
        path="/global-audit-logs"
        element={
          <ProtectedRoute allowedFeature={FEATURES.GLOBAL_AUDIT_LOGS}>
            <GlobalAuditLogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-management"
        element={
          <ProtectedRoute allowedFeature={FEATURES.USER_MANAGEMENT}>
            <UserManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/software-management"
        element={
          <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT]}>
            <SCMHome />
          </ProtectedRoute>
        }>
        <Route index element={<SoftwareManagementIndex />} />
        <Route
          path="find-package"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE]}>
              <FindPackage />
            </ProtectedRoute>
          } />
        <Route
          path="create-package"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE]}>
              <CreatePackage />
            </ProtectedRoute>
          } />

        <Route
          path="edit-package"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE]}>
              <CreatePackage />
            </ProtectedRoute>
          } />

        <Route
          path="select-dependencies"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE]}>
              <AddDependencies />
            </ProtectedRoute>
          } />
        <Route
          path="manage-dependencies"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE]}>
              <ManageDependencies />
            </ProtectedRoute>
          } />
        <Route
          path="package-summary"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE]}>
              <PublishPackageSummary />
            </ProtectedRoute>
          } />

        <Route
          path="find-package-deployment"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT]}>
              <FindPackage title='Find Package For Deployment' isDeployment={true} key="deployment" />
            </ProtectedRoute>
          } />

        <Route
          path="create-deployment"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT]}>
              <CreateDeployment />
            </ProtectedRoute>
          } />

        <Route
          path="select-targets"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT]}>
              <SelectTargets />
            </ProtectedRoute>
          } />

        <Route
          path="track-deployment"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT]}>
              <TrackDeployment />
            </ProtectedRoute>
          } />
        <Route
          path="track-deployment-assets"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT]}>
              <TrackDeploymentForAssets />
            </ProtectedRoute>
          } />
        <Route
          path="deployment-summary"
          element={
            <ProtectedRoute allowedFeature={[FEATURES.SCM_ADMIN, FEATURES.SCM_PACKAGE, FEATURES.SCM_DEPLOYMENT]}>
              <DeploymentSummary />
            </ProtectedRoute>
          } />
      </Route>
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}

export default AppRoutes;
